import { render } from "./circular-progress-v3.vue?vue&type=template&id=f560af9c&scoped=true"
import script from "./circular-progress-v3.vue?vue&type=script&lang=js"
export * from "./circular-progress-v3.vue?vue&type=script&lang=js"

import "./circular-progress-v3.vue?vue&type=style&index=0&id=f560af9c&lang=scss&scoped=true"

import exportComponent from "/Users/jigarpyunt/Desktop/ArrowDT/Git/SDB/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f560af9c"]])

export default __exports__